<section>
    <ng-container *ngIf="hasFieldOrEditable(rendering.fields.title)">
        <h1 *scRichText="rendering.fields.title"></h1>
    </ng-container>
    <ng-container *ngIf="hasFieldOrEditable(rendering.fields.body)">
        <p *scRichText="rendering.fields.body"></p>
    </ng-container>
    <div class="border"></div>
</section>
